<template>
  <form :method="method" :action="action" class="pa-front-form" @submit.prevent="handleSubmit">
    <div class="form-set" :class="formSetClass" v-for="(item, name) in formSet" :key="name">
      <div class="title">
        {{item.label}}
        <template v-if="validationMessagePosition === 'title'">
          <transition name="validation-fail">
            <span class="valid-error" v-if="item.isUnvalid === true">{{item.unvalidMessage}}</span>
          </transition>
        </template>
      </div>
      
      <template v-if="item.descriptionMinify === true">
        <div class="description description-small" v-if="item.description !== null" v-html="item.description"></div>
      </template>
      <template v-else>
        <div class="description" v-if="item.description !== null" v-html="item.description"></div>
      </template>
      
      <div class="input-area">
        <template v-if="item.inputType === 'password'">
          <input type="password" :name="name" autocapitalize="off" class="input" v-model="item.value" :disabled="item.isDisabled" />
        </template>
        <template v-else-if="item.inputType === 'textarea'">
          <textarea :name="name" autocapitalize="off" class="input" v-model="item.value" :disabled="item.isDisabled" ></textarea>
        </template>
        <template v-else-if="item.inputType === 'switch'">
          <div class="field pa-switch-field">
            <input
             :id="'pa-form-set-'+name+'-'+timeId"
             type="checkbox"
             :name="name"
             class="switch is-small"
             v-model="item.value"
             :disabled="item.isDisabled"
             @change="handleChangeSwitchValue(name)"
            />
            <label :for="'pa-form-set-'+name+'-'+timeId">{{item.switchLabel}}</label>
          </div>
        </template>
        <template v-else-if="item.inputType === 'button'">
          <button
           class="button is-small"
           :class="item.buttonClass"
           :disabled="item.isDisabled"
           @click.prevent="handleClickButton"
          >{{item.buttonText}}</button>
        </template>
        <template v-else>
          <input type="text" :name="name" autocapitalize="off" class="input" v-model="item.value" :disabled="item.isDisabled" />
        </template>
      </div>

      <template v-if="validationMessagePosition === 'bottom'">
          <transition name="validation-fail">
            <div class="validation-error" v-if="item.isUnvalid === true">
              <p><font-awesome-icon icon="exclamation-triangle" />{{item.unvalidMessage}}</p>
            </div>
          </transition>
      </template>
    </div>

    <slot name="additional-footer"></slot>

    <div class="form-set">
      <div class="submit-field" v-if="hasSubmitButton">
        <button type="submit" class="button" :class="submitButtonClass" :disabled="isDisabledSubmitButton" @click.prevent="handleSubmit">{{submitText}}</button>
      </div>
      <div class="cancel-field" v-if="hasCancelButton">
        <button class="button button-cancel" :class="cancelButtonClass" :disabled="isDisabledCancelButton" @click.prevent="handleCancel">{{cancelText}}</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props : {
    action : {
      default: '/'
    },

    method : {
      default: 'POST'
    },

    submitText : {
      default: '送信'
    },

    formSetClass  : {
      default: null,
    },

    formSet : {
      default: {}
    },

    submitLoading : {
      default: false
    },

    isDisabledButton  : {
      default: false
    },

    hasSubmitButton : {
      default: true
    },

    hasCancelButton : {
      default: false
    },

    cancelText  : {
      default: 'やめる'
    },

    validationMessagePosition : {
      default: 'title'
    }
  },
  
  data(){
    return {
      isDisabledSubmitButton  : false,
      submitButtonClass       : [],

      isDisabledCancelButton  : false,
      cancelButtonClass       : [],

      timeId                  : '',
    };
  },

  watch : {
    submitLoading : {
      handler(value){
        if(value){
          this.submitButtonClass = ['is-loading'];
          this.isDisabledSubmitButton = true;

          this.isDisabledCancelButton = true;

          for(let i in this.formSet){
            if(this.formSet[i].inputType === 'button'){
              this.formSet[i].buttonClass['is-loading'] = true;
            }
          }
        }else{
          this.submitButtonClass = [];
          this.isDisabledSubmitButton = false;

          this.isDisabledCancelButton = false;

          for(let i in this.formSet){
            if(this.formSet[i].inputType === 'button'){
              this.formSet[i].buttonClass['is-loading'] = false;
            }
          }
        }
      },
      immediate: true
    },

    isDisabledButton : {
      handler(value){
        if(value){
          this.isDisabledSubmitButton = true;
          this.isDisabledCancelButton = true;
        }else{
          this.isDisabledSubmitButton = false;
          this.isDisabledCancelButton = false;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleSubmit(){
      this.$emit('handleSubmit');
    },

    handleCancel(){
      this.$emit('handleCancel');
    },

    handleChangeSwitchValue(name){
      this.$emit('handleChangeSwitch', name);
    },

    handleClickButton(){
      this.$emit('handleClickButton');
    }
  },

  mounted(){
    // Switchのid for 要素用にユニークIDを取得
    this.timeId = (new Date()).getTime();
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "~bulma/sass/utilities/_all";

@import "~bulma-switch/src/sass/index.sass";

form.pa-front-form{
  div.form-set{
    div.input-area{
      margin-top:0;

      div.pa-switch-field{
        text-align: center;

        .is-small + label{
          padding-top:0;
        }

        .switch[type=checkbox]{
          
        }
      }
    }

    .description.description-small{
      font-size:.7rem;
    }
  }
}
</style>